import React from "react";
import _ from "lodash";
import { Group, NumberInput } from "@mantine/core";
import RemoteSelect2 from "./remoteSelect2";
import { useForceUpdate } from "@mantine/hooks";

const UserGroupMemberRow = ({ item, form, name, index }) => {
  const forceUpdate = useForceUpdate();

  return (
    <Group wrap="noWrap" grow>
      <RemoteSelect2
        label="Client"
        apiEntity="client"
        labelField="name"
        valueField="_id"
        labelRender={(data) => {
          let label = data.name || "";
          if (data.aliasName) label += ` (${data.aliasName})`;
          else if (data.cname) label += ` (${data.cname})`;
          if (data.code) label += ` [${data.code}]`;
          return label;
        }}
        multiple={false}
        searchFields={["name", "cname", "aliasName", "phone", "code"]}
        placeholder="Select Client"
        clearable={true}
        value={item.content["client"]}
        onDataChange={(data) => {
          item.content["client"] = data?._id;
          forceUpdate();
        }}
        sort={{
          by: "name",
          order: "asc",
        }}
      />
      <NumberInput
        label="Share %"
        placeholder="Share %"
        min={0}
        max={100}
        precision={2}
        value={item.content["sharePercent"]}
        onChange={(val) => {
          item.content["sharePercent"] = val;
          forceUpdate();
        }}
      />
    </Group>
  );
};

export default UserGroupMemberRow;
